import { makeAutoObservable } from 'mobx';
import { buildGroupContactInfoMap } from 'global/services-helpers/groupService';
import GroupModule from 'store/modules/group/groupModule';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';

interface QuoteFlowGroupInfoBlobInput {
  blobTitle: string;
  generalInfoMap: Record<string, string>;
  contactInfoMap?: Record<string, string> | null;
  effectiveDate: string;
}

export class QuoteFlowGroupInfoDelegate {
  private _groupModule: GroupModule;
  private _enrollmentPeriodModule: EnrollmentPeriodModule;

  public get moreInfoBlobInput(): QuoteFlowGroupInfoBlobInput | null {
    if (this._groupModule.isLoading) return null;
    const group = this._groupModule.group;

    return {
      blobTitle: group.name,
      generalInfoMap: {
        group: group.name,
      },
      contactInfoMap: buildGroupContactInfoMap(group.contactInfo),
      effectiveDate: this._enrollmentPeriodModule.enrollmentPeriod?.effectiveDate || '',
    };
  }

  constructor(groupModule: GroupModule, enrollmentPeriodModule: EnrollmentPeriodModule) {
    this._groupModule = groupModule;
    this._enrollmentPeriodModule = enrollmentPeriodModule;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
